<template>
  <div>
    <InfoAlert
      :showDismissibleAlert="showDismissibleAlert"
      :info="info"
      v-on:close="showDismissibleAlert = false"
    />

    <v-form ref="addForm" v-model="valid">
      <v-row>
        <v-col>
          <v-text-field
            outlined
            dense
            :loading="loading"
            v-model="form.query_text"
            :counter="100"
            :rules="nameRules"
            :label="$store.getters.getTextMap().query"
            required
          ></v-text-field>
        </v-col>
        <WorkspaceMachineParamForm
          :multiple="false"
          v-on:value="updateFormWithParam"
        />

        <v-col>
          <v-btn v-if="!loading" text outlined @click="onSubmit">
            {{ $store.getters.getTextMap().add }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>
<script>
import axios from "axios";
import InfoAlert from "@/components/InfoAlert";
import WorkspaceMachineParamForm from "@/components/forms/WorkspaceMachineParamForm.vue";
export default {
  name: "AddTupleToQueryParamMap",
  props: ["queryParamMap"],
  components: {
    InfoAlert,
    WorkspaceMachineParamForm,
  },
  data() {
    return {
      form: {
        name: null,
        query_id: null,
        query_text: null,
        param_id: null,
      },
      loading: false,
      info: null,
      showDismissibleAlert: false,
      valid: false,
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => /\S+/.test(v) || "Name is required",
        (v) =>
          (v && v.length <= 100 && v.length > 0) ||
          "Name cannot be more than 10 characters",
      ],
      numberRules: [
        (v) => !!v || "Required",
        (v) => /[0-9]+$/.test(v) || "It should be a number",
        (v) => (v && !isNaN(v)) || "It should be a valid number",
        (v) =>
          (v && v.length <= 8 && v.length > 0) ||
          "It must be less than 9 digits",
      ],
    };
  },
  methods: {
    updateFormWithParam(value) {
      this.form.param_id = value.parameter.param_id;
      // console.log(value.parameter)
    },
    onSubmit() {
      //evt.preventDefault();
      this.$refs.addForm.validate();
      if (this.valid) {
        this.loading = true;
        this.form.query_id = this.queryParamMap.query_id;
        // this.form.list_id = "l";
        // this.form.tag = "l";
        // this.form.value = "l";
        // this.form.query_key = "l";
        axios
          .post(this.$store.state.api + "addTupleToQueryParamMap", this.form, {
            headers: {
              Authorization: "Bearer " + this.$store.state.jwt,
            },
          })
          .then((response) => {
            if (response.data.status == "success" && response.data.tuple) {
              this.$store.dispatch("refreshQueryParamMapData");
              this.info = "Data added";
              this.showDismissibleAlert = true;
              this.loading = false;
              this.onReset();
              this.$emit("close");
            } else {
              this.info = response.data.msg;
              this.showDismissibleAlert = true;
            }
            //this.onReset()
            this.loading = false;
          })
          .catch((error) => {
            this.onReset();
            this.info = error;
            this.showDismissibleAlert = true;
            this.loading = false;
          });
      }
    },
    onReset() {
      //   this.$refs.addForm.reset();
      this.$emit("close");
    },
  },
};
</script>
